import React, { useState } from 'react';
import apiService from '../services/apiService';

const ChangePassword = ({ setCurrentPage }) => {
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [status, setStatus] = useState(null);   // { type: 'error' | 'success', message }
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async () => {
    // Checked here so an obvious mistake is caught before a round trip. The
    // server checks all of it again - this is a convenience, not the guard.
    if (!passwordForm.currentPassword || !passwordForm.newPassword) {
      setStatus({ type: 'error', message: 'Fill in every field.' });
      return;
    }
    if (passwordForm.newPassword.length < 8) {
      setStatus({ type: 'error', message: 'The new password must be at least 8 characters.' });
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setStatus({ type: 'error', message: 'The new password and its confirmation do not match.' });
      return;
    }
    if (passwordForm.newPassword === passwordForm.currentPassword) {
      setStatus({ type: 'error', message: 'The new password must be different from the current one.' });
      return;
    }

    setSaving(true);
    setStatus(null);
    try {
      const res = await apiService.changePassword(passwordForm);
      setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setStatus({
        type: 'success',
        message: (res && res.message) ||
          'Password changed. Please sign in again with your new password.'
      });
    } catch (err) {
      setStatus({
        type: 'error',
        message: (err && err.message) ||
          'Could not change the password. Please try again.'
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Change Password</h1>
        <p className="text-gray-600">Update your account password</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border p-6 max-w-md">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Current Password</label>
            <input
              type="password"
              value={passwordForm.currentPassword}
              onChange={(e) => setPasswordForm({...passwordForm, currentPassword: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
            <input
              type="password"
              value={passwordForm.newPassword}
              onChange={(e) => setPasswordForm({...passwordForm, newPassword: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
            <input
              type="password"
              value={passwordForm.confirmPassword}
              onChange={(e) => setPasswordForm({...passwordForm, confirmPassword: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
          
          <div className="flex space-x-4">
            <button
              onClick={() => setCurrentPage('profile')}
              className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleChangePassword}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              Update Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;